import React from 'react';
import StepConnector from '@mui/material/StepConnector';
import PropTypes from 'prop-types';

const VerticalStepConnector = ({ connectorColor, iconSize }) => (
  <StepConnector
    sx={{
      ml: 0,
      width: iconSize,
      height: iconSize,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: connectorColor,
      '& .MuiStepConnector-line': {
        height: 'inherit',
        border: 2,
        borderColor: connectorColor,
      },
      '&.Mui-active .MuiStepConnector-line': {
        borderColor: 'primary.main',
      },
      '&.Mui-completed .MuiStepConnector-line': {
        borderColor: 'primary.main',
      },
    }}
  />
);

VerticalStepConnector.propTypes = {
  connectorColor: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
};
VerticalStepConnector.defaultProps = {
  iconSize: '45px',
};

export default VerticalStepConnector;
